<template>
	<div>
		<div class="create-message" @click="toMessageCreate">写留言</div>
		<div class="message-hot">
			<h1>热门留言</h1>
			<ul>
				<li v-for="(item, index) in  dataList" :key="item.id" @click="toDetail(item)">
					<span class="hot-num">{{index+1}}</span>
					<p>{{item.title}}</p>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post, ajaxParam } from '@/units/request.js'
	export default {
		name: 'messageHot',
		props: {
			
		},
		data(){
			return{
				activityId: '',
				userId: '',
				pageNum: 1,
				pageSize: 10,
				dataList: []
			}
		},
		methods: {
			toDetail(item){
				this.$router.push({
					path: '/messageBoard/messageDetail',
					query: {
						id: item.id
					}
				})
			},
			//获取热门留言
			async getDataList(){
				let url = 'v1/suggest/hotList'
				let param = {
					activityId: this.activityId,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post(url, qs.stringify(param))
				if(res.data.code==200) {
					this.dataList = res.data.list
				} else {
					this.$message.error(res.data.msg)
				}
			},
			toMessageCreate(){
				if(!this.userId){
					this.$router.push('/login')
					return
				}
				this.$router.push({
					path: '/messageBoard/messageCreate'
				})
			}
		},
		created(){
			this.userId = localStorage.getItem('userId')
			this.activityId = localStorage.getItem('activityId')
			this.getDataList()
		}
	}
</script>

<style scoped lang="less">
	.create-message{
		width: 100%;
		height: 54px;
		margin-bottom: 20px;
		background: #DE0515;
		color: #fff;
		text-align: center;
		line-height: 54px;
		font-size: 25px;
		cursor: pointer;
	}
	.message-hot{
		background: #fff;
		padding: 18px;
		color: #4a4a4a;
		h1{
			padding-bottom: 10px;
			font-size: 15px;
			font-weight: bold;
		}
		li{
			display: flex;
			margin-bottom: 10px;
			align-items: center;
			min-height: 30px;
			cursor: pointer;
			.hot-num{
				width: 34px;
				margin-right: 10px;
				margin-left: -15px;
				font-size: 15px;
				font-weight: bold;
				color: #000;
				display: flex;
				justify-content: flex-end;
			}
			p{
				font-size: 12px;
				line-height: 18px;
				flex: 1
			}
		}
		li:nth-of-type(1){
			.hot-num{
				font-size: 30px;
				background: linear-gradient(180deg, #F3DE9D 0%, #E0C770 100%);
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
				line-height: 30px;
			}
		}
		li:nth-of-type(2){
			.hot-num{
				font-size: 30px;
				background: linear-gradient(180deg, #ECECEC 0%, #D4D3D4 100%);
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
				line-height: 30px;
			}
		}
		li:nth-of-type(3){
			.hot-num{
				font-size: 30px;
				background: linear-gradient(180deg, #E2C19E 0%, #BF976A 100%);
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
				line-height: 30px;
			}
		}
	}
</style>
